import { render, staticRenderFns } from "./DetalleCuentaCorriente.vue?vue&type=template&id=7cc250bc"
import script from "./DetalleCuentaCorriente.vue?vue&type=script&lang=js"
export * from "./DetalleCuentaCorriente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports